module.exports = __webpack_public_path__ + "media/images/responsive/articles/fair_banner_title_sub-25406cf1c36d0d5f95c309b7d4442b1e.png";